export const BASE_PET_TYPES = [
  { label: 'Dog', value: 'DOG' },
  { label: 'Cat', value: 'CAT' },
  { label: 'Other', value: 'OTHER' },
];

export const OTHER_PET_TYPES = [
  { display: 'Bird', value: 'BIRD' },
  { display: 'Fish', value: 'FISH' },
  { display: 'Guinea pig', value: 'GUINEA_PIG' },
  { display: 'Hamster', value: 'HAMSTER' },
  { display: 'Gerbil', value: 'GERBIL' },
  { display: 'Rabbit', value: 'RABBIT' },
  { display: 'Reptile', value: 'REPTILE' },
  { display: 'Ferret', value: 'FERRET' },
  { display: 'Small rodent', value: 'SMALL_RODENT' },
  { display: 'Amphibian', value: 'AMPHIBIAN' },
  { display: 'Other', value: 'OTHER' },
];

export const DOG_SIZES = [
  { label: 'Small (under 10 lbs)', value: 'SMALL' },
  { label: 'Medium (10-30 lbs)', value: 'MEDIUM' },
  { label: 'Large (30+ lbs)', value: 'LARGE' },
];

export const DOG_CARE_RESPONSIBILITIES = [
  { label: 'Walking', value: 'WALKING' },
  { label: 'Feeding', value: 'FEEDING' },
  { label: 'Playing', value: 'PLAYING' },
  { label: 'Administering Medication', value: 'ADMINISTERING_MEDICATION' },
];

export const CAT_CARE_RESPONSIBILITIES = [
  { label: 'Litter box cleaning', value: 'LITTER_MAINTENANCE' },
  { label: 'Feeding', value: 'FEEDING' },
  { label: 'Playing', value: 'PLAYING' },
  { label: 'Administering medication', value: 'ADMINISTERING_MEDICATION' },
];

export const OTHER_PET_CARE_RESPONSIBILITIES = [
  { label: 'Cleaning/maintenance', value: 'CLEANING_MAINTENANCE' },
  { label: 'Feeding', value: 'FEEDING' },
  { label: 'Playing', value: 'PLAYING' },
];

export const DOG_BREEDS = [
  'Affenpinscher',
  'Afghan Hound',
  'Aidi',
  'Airedale Terrier',
  'Akbash',
  'Akita',
  'Alaskan Klee Kai',
  'Alaskan Malamute',
  'American Bulldog',
  'American Bully',
  'American Cocker Spaniel',
  'American Corgi',
  'American English Coonhound',
  'American Eskimo Dog',
  'American Foxhound',
  'American Hairless Terrier',
  'American Leopard Hound',
  'American Pit Bull Terrier',
  'American Staffordshire Terrier',
  'American Water Spaniel',
  'Anatolian Shepherd Dog',
  'Appenzeller Sennenhund',
  'Atlas Mountain Dog',
  'Aussiedoodle',
  'Australian Cattle Dog',
  'Australian Kelpie',
  'Australian Labradoodle',
  'Australian Mountain Doodle',
  'Australian Shepherd',
  'Australian Stumpy Tail Cattle Dog',
  'Australian Terrier',
  'Azawakh',
  'Barbet',
  'Basenji',
  'Basset Hound',
  'Bavarian Mountain Scent Hound',
  'Beagle',
  'Bearded Collie',
  'Beauceron',
  'Bedlington Terrier',
  'Belgian Laekenois',
  'Belgian Malinois',
  'Belgian Sheepdog',
  'Belgian Shepherd Dog',
  'Belgian Tervuren',
  'Bergamasco Sheepdog',
  'Berger des Pyrenees',
  'Berger Picard',
  'Bernedoodle',
  'Bernese Mountain Dog',
  'Bichon Frise',
  'Biewer Terrier',
  'Black and Tan Coonhound',
  'Black Mouth Cur',
  'Black Russian Terrier',
  'Bloodhound',
  'Blue Lacy',
  'Bluetick Coonhound',
  'Boerboel',
  'Bohemian Shepherd',
  'Bolognese',
  'Bolonka',
  'Border Collie',
  'Border Terrier',
  'Bordoodle',
  'Borzoi',
  'Boston Terrier',
  'Bouvier des Flandres',
  'Boxer',
  'Boykin Spaniel',
  'Bracco Italiano',
  'Braque du Bourbonnais',
  'Braque Francais Pyrenean',
  'Briard',
  'Brittany',
  'Broholmer',
  'Brussels Griffon',
  'Bull Terrier',
  'Bulldog',
  'Bullmastiff',
  'Cairn Terrier',
  'Canaan Dog',
  'Canadian Eskimo Dog',
  'Cane Corso',
  'Cardigan Welsh Corgi',
  'Carolina Dog',
  'Catahoula Leopard Dog',
  'Caucasian Shepherd Dog',
  'Cavalier King Charles Spaniel',
  'Cavapoo',
  'Central Asian Shepherd',
  'Cesky Fousek',
  'Český Fousek',
  'Cesky Terrier',
  'Chesapeake Bay Retriever',
  'Chihuahua',
  'Chinese Crested',
  'Chinese Shar-Pei',
  'Chinook',
  'Chiweenie',
  'Chorkie',
  'Chow Chow',
  "Cirneco dell'Etna",
  'Clumber Spaniel',
  'Cockapoo',
  'Cocker Spaniel',
  'Collie',
  'Coton de Tulear',
  'Croatian Sheepdog',
  'Curly-Coated Retriever',
  'Czechoslovakian Vlcak',
  'Dachshund',
  'Dalmatian',
  'Dandie Dinmont Terrier',
  'Danish-Swedish Farmdog',
  'Deutscher Wachtelhund',
  'Doberman Pinscher',
  'Dogo Argentino',
  'Dogue de Bordeaux',
  'Double Doodle',
  'Drentsche Patrijshond',
  'Drever',
  'Dutch Shepherd',
  'English Cocker Spaniel',
  'English Coonhound',
  'English Foxhound',
  'English Setter',
  'English Shepherd',
  'English Springer Spaniel',
  'English Toy Spaniel',
  'Entlebucher Mountain Dog',
  'Epagneul Francais',
  'Estrela Mountain Dog',
  'Eurasier',
  'Field Spaniel',
  'Finnish Lapphund',
  'Finnish Spitz',
  'Flat-Coated Retriever',
  'French Bulldog',
  'French Spaniel',
  'Gerberian Shepsky',
  'German Longhaired Pointer',
  'German Pinscher',
  'German Shepherd Dog',
  'German Shorthaired Pointer',
  'German Spitz',
  'German Wirehaired Pointer',
  'Giant Schnauzer',
  'Glen of Imaal Terrier',
  'Golden Mountain Dog',
  'Golden Mountain Doodle',
  'Golden Retriever',
  'Goldendoodle',
  'Gordon Setter',
  'Grand Basset Griffon Vendeen',
  'Great Dane',
  'Great Danoodle',
  'Great Pyrenees',
  'Greater Swiss Mountain Dog',
  'Greyhound',
  'Hamiltonstovare',
  'Hanoverian Scenthound',
  'Harrier',
  'Havanese',
  'Havapoo',
  'Hokkaido',
  'Hovawart',
  'Huskydoodle',
  'Ibizan Hound',
  'Icelandic Sheepdog',
  'Irish Doodle',
  'Irish Red and White Setter',
  'Irish Setter',
  'Irish Terrier',
  'Irish Water Spaniel',
  'Irish Wolfhound',
  'Italian Greyhound',
  'Jack Russell Terrier',
  'Jagdterrier',
  'Japanese Akitainu',
  'Japanese Chin',
  'Japanese Spitz',
  'Japanese Terrier',
  'Jindo',
  'Kai Ken',
  'Kangal',
  'Karelian Bear Dog',
  'Keeshond',
  'Kelpie',
  'Kerry Blue Terrier',
  'Kishu Ken',
  'Komondor',
  'Kooikerhondje',
  'Koolie',
  'Kromfohrlander',
  'Kuvasz',
  'Labradoodle',
  'Labrador Retriever',
  'Lagotto Romagnolo',
  'Lakeland Terrier',
  'Lancashire Heeler',
  'Lapponian Herder',
  'Large Munsterlander',
  'Leonberger',
  'Lhasa Apso',
  'Llewellin Setter',
  'Lowchen',
  'Lurcher',
  'Maltese',
  'Maltipoo',
  'Manchester Terrier',
  'Maremma Sheepdog',
  'Mastiff',
  'McNab',
  'Mi-Ki',
  'Miniature American Shepherd',
  'Miniature Australian Shepherd',
  'Miniature Bull Terrier',
  'Miniature Dachshund',
  'Miniature Golden Retriever',
  'Miniature Goldendoodle',
  'Miniature Pinscher',
  'Miniature Poodle',
  'Miniature Schnauzer',
  'Mixed Breed',
  'Morkie',
  'Mountain Cur',
  'Mudi',
  'Neapolitan Mastiff',
  'Nederlandse Kooikerhondje',
  'Newfoundland',
  'Newfypoo',
  'Norfolk Terrier',
  'Norrbottenspets',
  'Norwegian Buhund',
  'Norwegian Elkhound',
  'Norwegian Lundehund',
  'Norwich Terrier',
  'Nova Scotia Duck Tolling Retriever',
  'Old English Sheepdog',
  'Otterhound',
  'Papillon',
  'Parson Russell Terrier',
  'PBGV',
  'Pekingese',
  'Pembroke Welsh Corgi',
  'Perro de Presa Canario',
  'Peruvian Inca Orchid',
  'Petit Basset Griffon Vendeen',
  'Pharaoh Hound',
  'Pinscher',
  'Pit Bull',
  'Plott Hound',
  'Pointer',
  'Polish Lowland Sheepdog',
  'Pomeranian',
  'Pompoo',
  'Pomsky',
  'Poodle',
  'Porcelaine',
  'Portuguese Podengo',
  'Portuguese Podengo Pequeno',
  'Portuguese Pointer',
  'Portuguese Sheepdog',
  'Portuguese Water Dog',
  'Pudelpointer',
  'Pug',
  'Puggle',
  'Puli',
  'Pumi',
  'Pyrenean Mastiff',
  'Pyrenean Shepherd',
  'Rat Terrier',
  'Redbone Coonhound',
  'Rhodesian Ridgeback',
  'Romanian Mioritic Shepherd Dog',
  'Rottweiler',
  'Russell Terrier',
  'Russian Toy',
  'Russian Tsvetnaya Bolonka',
  'Russkiy Toy',
  'Saint Bernard',
  'Saluki',
  'Samoyed',
  'Sarplaninac',
  'Schapendoes',
  'Schipperke',
  'Schnoodle',
  'Scottish Deerhound',
  'Scottish Terrier',
  'Sealyham Terrier',
  'Segugio Italiano',
  'Sheepadoodle',
  'Shetland Sheepdog',
  'Shiba Inu',
  'Shih Poo',
  'Shih Tzu',
  'Shikoku',
  'Shiloh Shepherd',
  'Siberian Husky',
  'Silken Windhound',
  'Silky Terrier',
  'Skye Terrier',
  'Sloughi',
  'Slovakian Wirehaired Pointer',
  'Slovensky Cuvac',
  'Slovensky Kopov',
  'Small Munsterlander',
  'Smooth Fox Terrier',
  'Soft Coated Wheaten Terrier',
  'Spanish Mastiff',
  'Spanish Water Dog',
  'Spinone Italiano',
  'Springerdoodle',
  'Stabyhoun',
  'Staffordshire Bull Terrier',
  'Standard Poodle',
  'Standard Schnauzer',
  'Sussex Spaniel',
  'Swedish Lapphund',
  'Swedish Vallhund',
  'Taiwan Dog',
  'Tamaskan',
  'Teddy Roosevelt Terrier',
  'Thai Ridgeback',
  'Tibetan Mastiff',
  'Tibetan Spaniel',
  'Tibetan Terrier',
  'Tornjak',
  'Tosa',
  'Toy Australian Shepherd',
  'Toy Fox Terrier',
  'Toy Poodle',
  'Transylvanian Hound',
  'Treeing Tennessee Brindle',
  'Treeing Walker Coonhound',
  'Vizsla',
  'Volpino Italiano',
  'Weimaraner',
  'Welsh Springer Spaniel',
  'Welsh Terrier',
  'West Highland White Terrier',
  'Westiepoo',
  'Wetterhoun',
  'Whippet',
  'Whoodle',
  'Wire Fox Terrier',
  'Wirehaired Pointing Griffon',
  'Wirehaired Vizsla',
  'Xoloitzcuintli',
  'Yakutian Laika',
  'Yorkipoo',
  'Yorkshire Terrier',
] as const;

export const PET_REQUIRES_CARE = [
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' },
];

export const getBreedsForSearchComboBox = (): { display: string; value: string }[] => {
  return DOG_BREEDS.map((breed) => ({
    display: breed,
    value: breed.split(' ').join('_').toUpperCase(),
  }));
};
